export enum AllBwicsTab {
    All,
    Buy,
    Sell
}
